import { render } from "./Modal.vue?vue&type=template&id=0ec84343"
import script from "./Modal.js?vue&type=script&lang=js"
export * from "./Modal.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__